import React, { CSSProperties, useEffect, useState } from "react";
import {
	logoEComicSR,
	sr01img,
	sr02img,
	sr03img,
	sr04img, srComic
} from "../../model/DataConst";
import mangaInfo from "../../model/MangaInfo";
import { createImageStyle, createSeparateImageSet } from "../../model/VertMangaUtils";
import "./ECSVerticalScroll.scss";
import SampleLinkButton from "../parts/SampleLinkButton";
import { DefaultMangaState, IMangaDisplayInfo, MangaHeader, StoryShow } from "../parts/MangaView";
import { OrientationContext } from "../../provider/OrientationProvider";
import { ECSR_URL, MAX_WIDTH, MAX_WIDTH_STR } from "../../model/Const";
import { IUADevice, userAgentInfo } from "../../model/UserAgentInfo";
import { IntroImg, OnePictureDiv } from "./VerticalScrollUtils";

const createDisplayInfo = () => {
	const sr03imageSet = createSeparateImageSet( mangaInfo.sr03info );
	// const sr04imageSet = createSeparateImageSet( mangaInfo.sr04info, 60 );

	const list: IMangaDisplayInfo[] = [];
	list.push( {
		src: sr01img,
		alt: "eComicSRの紹介まんが 1",
		needScroll: false,
		style: createImageStyle( mangaInfo.sr01info ),
		alignHorizontal: mangaInfo.sr01info.width / window.innerWidth < mangaInfo.sr01info.height / window.innerHeight,
		info: mangaInfo.sr01info
	} );
	list.push( {
		src: sr02img,
		alt: "eComicSRの紹介まんが 2",
		needScroll: false,
		style: createImageStyle( mangaInfo.sr02info ),
		alignHorizontal: mangaInfo.sr02info.width / window.innerWidth < mangaInfo.sr02info.height / window.innerHeight,
		info: mangaInfo.sr02info
	} );
	list.push( {
		src: sr03img,
		alt: "eComicScreen+の紹介まんが 3",
		needScroll: true,
		style: sr03imageSet.style,
		// parentStyle: sr03imageSet.parentStyle,
		from: sr03imageSet.from,
		to: sr03imageSet.to,
		duration: "100%",
		alignHorizontal: mangaInfo.sr03info.width / window.innerWidth < mangaInfo.sr03info.height / window.innerHeight,
		info: mangaInfo.sr03info
	} );
	list.push( {
		src: sr04img,
		alt: "eComicScreen+の紹介まんが 4",
		needScroll: false,
		style: createImageStyle( mangaInfo.sr04info ),
		// style: sr04imageSet.style,
		// // parentStyle: sr04imageSet.parentStyle,
		// from: sr04imageSet.from,
		// to: sr04imageSet.to,
		// duration: "20%",
		alignHorizontal: mangaInfo.sr04info.width / window.innerWidth < mangaInfo.sr04info.height / window.innerHeight,
		info: mangaInfo.sr04info
	} );

	return list;
};

const ECSRVerticalScroll = ( props: { isSmallMedia: boolean } ) => {
	// トリガーとなる要素
	const triggerRef = React.useRef<HTMLDivElement>( null );

	// トリガーとなるID
	const [triggerId, setTriggerId] = React.useState( "" );
	const [mangaState, setMangaState] = useState( DefaultMangaState );

	// コンテキスト
	const context = React.useContext( OrientationContext );

	useEffect( () => {
		mangaInfo.addWaitKomaFunc( () => {
			setMangaState( {
				displayInfoList: createDisplayInfo(),
				loaded: true,
				defaultHeight: window.innerHeight
			} );
		} );

		setTriggerId( "#ecsrHeader" );
	}, [] );

	// 最大幅を設定するスタイル（PCの場合のみ設定）
	const maxWidthStyle = React.useMemo( () => {
		// 幅が最大幅より大きく、PCだったら最大幅を指定
		if ( window.innerWidth > MAX_WIDTH && userAgentInfo.device === IUADevice.pc ) {
			return {
				max: {
					maxWidth: MAX_WIDTH_STR,
					margin: "auto"
				} as CSSProperties,
				headerSpan: {
					fontSize: "2.5rem"
				} as CSSProperties,
				img: {
					height: "100px"
				} as CSSProperties
			}
		}

		return {
			max: undefined,
			headerSpan: undefined,
			img: {
				width: "49vw"
			} as CSSProperties
		};
	}, [context.resize] );

	return (
		<>
			{/*タイトル*/}
			<div
				ref={triggerRef}
				id="ecsrHeader"
			/>

			<section>
				{/*ヘッダー*/}
				<MangaHeader
					triggerId={triggerId}
					src={logoEComicSR}
					alt={"eComicSR"}
					message={"小さな画像をキレイに拡大することに特化した"}
					imgStyle={maxWidthStyle.img}
					headerStyle={maxWidthStyle.max}
					headerSpanStyle={maxWidthStyle.headerSpan}
				/>

				{/*紹介漫画*/}
				{/*小さいメディアではスクロールに*/}
				<StoryShow
					mangaState={mangaState}
					className={"ecsr"}
					show={props.isSmallMedia}
				/>
				{/*大きいメディアでは1枚画像に*/}
				<OnePictureDiv style={{ display: props.isSmallMedia ? "none" : undefined }} className={"ecsr"}>
					<div style={maxWidthStyle.max}>
						<IntroImg src={srComic} alt={"eComicSR紹介コミック"}/>
					</div>
				</OnePictureDiv>

				{/*サンプルリンク*/}
				<SampleLinkButton
					toURL={ECSR_URL}
					text={"サンプルはこちら"}
				/>
			</section>
		</>);
};

export default ECSRVerticalScroll;